import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  Layout,
  Card,
  Button,
  Input,
  Radio,
  Form,
  Select,
  InputNumber,
  Checkbox,
  Popconfirm,
  message,
} from "antd";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { useSelector } from "react-redux";
import CustomThemeDrawer from "../../../../../Elements/CustomThemeDrawer";
import { APIConstants } from "../../../../../../Common/APIConstants";
import { useStoreUpdaterWithAPI } from "../../../../../../Hooks/UseStoreUpdaterWithApi";
import {
  EditOutlined,
  DeleteOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";

const DashboardLayout = () => {
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);
  const [selectedAlert, setSelectedAlert] = useState({ label: "", key: "" });
  const [selectedAlertTable, setSelectedAlertTable] = useState(null);
  const [alertsData, setAlertsData] = useState([]);
  const [form3] = Form.useForm();
  const [form2] = Form.useForm();
  const { makeRequest } = useStoreUpdaterWithAPI();
  const [subCategory, setSubCategory] = useState();
  const gridRef = useRef();
  const [refetch2, setRefetch2] = useState(false);
  const [refetch, setRefetch] = useState(false);
  const [alerts, setAlerts] = useState([]);
  const [subFormCategories, setSubFormCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [recipients, setRecipients] = useState();
  const [recipient, setRecipient] = useState();
  const [selectedSubCategory, setSelectedSubCategory] = useState();

  const handleNotification = (msg, type) => {
    message.open({
      content: `${msg}`,
      type: type,
    });
  };

  const alertsCols = [
    {
      checkboxSelection: true,
      headerCheckboxSelection: false,
      width: 50,
    },
    // {
    //   headerName: "Alert ID",
    //   field: "alertID",
    //   sortable: true,
    //   filter: true,
    //   minWidth: 120,
    //   flex: 1,
    // },
    {
      headerName: "Alert Name",
      field: "alertName",
      sortable: true,
      filter: true,
      minWidth: 120,
      flex: 1,
    },
  ];
  const subCategoryCols = [
    {
      checkboxSelection: true,
      headerCheckboxSelection: false,
      width: 50,
    },
    // {
    //   headerName: "Sub Auto ID",
    //   field: "subAutoID",
    //   sortable: true,
    //   filter: true,
    //   minWidth: 120,
    //   flex: 1,
    // },
    {
      headerName: "Sub Category",
      field: "subCatagory",
      sortable: true,
      filter: true,
      minWidth: 120,
      flex: 1,
    },
    {
      headerName: "Actions",
      minWidth: 130,
      flex: 1,
      cellRenderer: (params) => {
        return (
          <div className="space-x-2">
            {/* <span
  className="text-green-500 bg-green-200 p-2 cursor-pointer shadow-lg rounded-md px-4 transition-transform duration-200 hover:border-[1px] border-green-400"
              onClick={() => {
                setOpen2(true);
                setUpdateTariffData(true);
                form2.setFieldsValue({
                  tariffAutoID: params.data.tariffAutoID,
                  tariffName: params.data.tariffName,
                  unitCost: params.data.unitCost,
                });
              }}
            >
              <EditOutlined />
            </span> */}

            <Popconfirm
              title="Are you sure to delete ?"
              // description="Are you sure to delete this Converter Configuration?"
              icon={<QuestionCircleOutlined style={{ color: "red" }} />}
              onConfirm={() => deleteSubCategory(params.data)}
              trigger="click"
            >
              <span
                className="text-red-500 bg-red-200 p-2 cursor-pointer shadow-lg rounded-md px-4 
             transition-transform duration-200 hover:border-[1px] border-red-400"
              >
                <DeleteOutlined />
              </span>
            </Popconfirm>
          </div>
        );
      },
    },
  ];

  const deleteSubCategory = (formValues) => {
    //console.log(formValues);

    const body = {
      alertAutoID: formValues.subAutoID,
    };

    const url = `${APIConstants.ELECTRICAL_DELETE_SUB_CATEGORY}?AlertAutoID=${formValues.subAutoID}`;

    //console.log(url);
    //console.log(body);

    makeRequest({
      type: APIConstants.DELETE,
      url: url,
      // body: body,
    }).then((res) => {
      //console.log(res);
      onClose2();
      setRefetch2(!refetch2);
      handleNotification("Successfully Deleted", "success");
    });
  };
  const onSelectionChanged = useCallback(() => {
    const selectedRows = gridRef.current.api.getSelectedRows();
    //console.log("Selected Rows:", selectedRows[0]);
    if(selectedRows[0]!==undefined){
      setSelectedSubCategory(selectedRows[0]?.subAutoID);
    }else{
      setSelectedSubCategory(null);
      setRecipients([])
      setRecipient([])
      
    }
  }, []);
  const alertsRef = useRef(null);

  const onAlertsSelection = () => {
    const selectedRows = alertsRef.current.api.getSelectedRows();
    //console.log("Selected Row:", selectedRows[0]); 
    if(selectedRows[0]!==undefined){
      setSelectedAlertTable(selectedRows[0]?.alertID);
    }else{
      setSelectedAlertTable(null);
      setSubCategories([])
      setSubCategory([])
      setRecipients([])
      setRecipient([])
    }
  };

  const getAlerts = (inputData) => {
    //console.log(inputData);
    const url = `${APIConstants.ELECTRICAL_GET_ALERTS}`;
    //console.log(url);

    makeRequest({
      type: APIConstants.GET,
      url: url,
      // body:formValues
    }).then((res) => {
      //console.log(res);
      if (res) {
        setAlerts(res);
        setAlertsData(res);
      }
    });
  };
  const getRecipients = (inputData) => {
    //console.log(inputData);
    const url = `${APIConstants.ELECTRICAL_GET_RECIPIENTS}?SubAutoID=${inputData}`;
    //console.log(url);
    if(inputData&&inputData!=='undefined'){
      makeRequest({
        type: APIConstants.GET,
        url: url,
        // body:formValues
      }).then((res) => {
        //console.log(res);
        if (res) {
          setRecipient(res);
          setRecipients(res);
          // setAlertsData(res);
        }
      });
    }
  };
  const getsubCategoryForm = (inputData) => {
    //console.log(inputData);
    const url = `${APIConstants.ELECTRICAL_GET_SUB_CATEGORY}?AlertAutoID=${inputData}`;
    //console.log(url);

    makeRequest({
      type: APIConstants.GET,
      url: url,
      // body:formValues
    }).then((res) => {
      //console.log(res);
      if (res) {
        setSubFormCategories(res);
        // setSubCategories(res)
      }
    });
  };
  const getsubCategory = (inputData) => {
    //console.log(inputData);
    const url = `${APIConstants.ELECTRICAL_GET_SUB_CATEGORY}?AlertAutoID=${inputData}`;
    //console.log(url);
    if (inputData&&inputData!=='undefined')
      makeRequest({
        type: APIConstants.GET,
        url: url,
        // body:formValues
      }).then((res) => {
        //console.log(res);
        if (res) {
          setSubCategory(res);
          setSubCategories(res);
        }
      });
  };
  const insertsubCategory = (inputData) => {
    //console.log(inputData);
    const body = {
      subCatagory: inputData.subCategory,
      alertAutoID: inputData.alerts,
    };
    form2.resetFields();
    onClose2();
    const url = `${APIConstants.ELECTRICAL_INSERT_SUB_CATEGORY}`;
    //console.log(url);

    makeRequest({
      type: APIConstants.POST,
      url: url,
      body: body,
    }).then((res) => {
      console.log(res);
      handleNotification(res.message||'',res?.message.includes('success')? "success":"error")
      if (res) {
        // setAlerts(res);
        setRefetch2(!refetch2)
        // setAlertsData(res);
      }
    });
  };
  const insertRecipient = (inputData) => {
    // console.log(inputData);
    // recipientType: [ 'to', 'cc' ],
    // emailID: 'vijay@gmail.com'
    // selectedAlert?.label !== "Email"
    const body = {
      alertID: Number(inputData?.alerts?.key) || 0,
      subCategoryID: Number(inputData?.subCategory?.key) || 0,
      phoneNumber: inputData?.PhoneNumber || "",
      recipientName:inputData?.name||''
    };
    const body2 = {
      alertID: Number(inputData?.alerts?.key) || 0,
      subCategoryID: Number(inputData?.subCategory?.key) || 0,
      recipient: inputData?.emailID || "",
      recipientName: inputData.recipientName||"",
      phoneNumber: String(inputData?.PhoneNumber) || "",
      isTo: inputData?.recipientType?.includes("to") ? true : false || false,
      isCC: inputData?.recipientType?.includes("cc") ? true : false || false,
      isBCC: inputData?.recipientType?.includes("bcc") ? true : false || false,
    };
    // console.log(body2);
    // form2.resetFields();
    // onClose2();
    const url = `${APIConstants.ELECTRICAL_INSERT_RECEPIENT}`;
    //console.log(url);

    makeRequest({
      type: APIConstants.POST,
      url: url,
      body: body2,
    }).then((res) => {
      // console.log(res);
      if (res) {
        handleNotification(res.message||'',res?.message.includes('success')? "success":"error")
        setRefetch(!refetch)
        form3.resetFields();
    onClose3();
      }
    });
  };

  useEffect(() => {
    getsubCategory(selectedAlertTable);
  }, [selectedAlertTable, refetch2]);
  useEffect(() => {
    getsubCategoryForm(selectedAlert.key);
  }, [selectedAlert]);
  useEffect(() => {
    getAlerts();
  }, []);
  useEffect(() => {
    getRecipients(selectedSubCategory);
  }, [selectedSubCategory,refetch]);
  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    // form.resetFields()
    setOpen(false);
  };
  const showDrawer2 = () => {
    setOpen2(true);
  };

  const onClose2 = () => {
    form2.resetFields();
    setOpen2(false);
  };
  const showDrawer3 = () => {
    setOpen3(true);
  };

  const onClose3 = () => {
    form3.resetFields();
    setOpen3(false);
  };
  const mode = useSelector((state) => state.darkMode);
  const color = useSelector((state) => state.ThemeChange);
  //console.log(color);
  const { isdarkMode } = mode;
  //console.log(recipients);
  const recepientCols1 = useMemo(
    () => [
      // { headerName: "Recipient ID", field: "recipientID", width: 80 },
      { headerName: "Recipient Name", field: "recipientName", flex: 1,minWidth:120 },
      { headerName: "Phone Number", field: "phoneNumber", flex: 1 },
    ],
    []
  );
  const recepientCols2 = useMemo(
    () => [
      // { headerName: "Recipient ID", field: "recipientID", width: 80 },
      { headerName: "Recipient Name", field: "recipientName", flex: 1,minWidth:120 },
      { headerName: "Recipient", field: "recipient", flex: 1,minWidth:120 },
      // { headerName: "Phone Number", field: "phoneNumber", flex: 1,minWidth:150 },
      {
        headerName: "To",
        field: "isTo",
        cellRenderer: (params) => {
          return <Radio checked={params.value == "True"} />;
        },
        width: 100,
      },
      {
        headerName: "CC",
        field: "isCC",
        cellRenderer: (params) => {
          return <Radio checked={params.value == "True"} />;
        },
        width: 100,
      },
      {
        headerName: "BCC",
        field: "isBCC",
        cellRenderer: (params) => {
          return <Radio checked={params.value == "True"} />;
        },
        width: 100,
      },
    ],
    []
  );


  const handleAlertsSearch = (value) => {
    const fullQuery = value.trim().toLowerCase();
    if (!fullQuery) {
      setAlerts(alertsData);
      return;
    }
    setAlerts(
      alertsData.filter((item) =>
        item.alertName.toLowerCase().includes(fullQuery)
      )
    );
  };

  const handleSubCategoriesSearch = (value) => {
    const fullQuery = value.trim().toLowerCase();
    if (!fullQuery) {
      setSubCategories(subCategory);
      return;
    }
    setSubCategories(
      subCategory.filter((item) =>
        item.subCatagory.toLowerCase().includes(fullQuery)
      )
    );
  };

  const handleRecipientsSearch = (value) => {
    const fullQuery = value.trim().toLowerCase();
    if (!fullQuery) {
      setRecipients(recipient);
      return;
    }
    setRecipients(
      recipient.filter(
        (item) =>
          item.recipient.toLowerCase().includes(fullQuery) ||
          String(item.sno).includes(fullQuery)
      )
    );
  };
  console.log(selectedAlertTable)
  return (
    <div
      className={`p-4 min-h-screen  ${isdarkMode ? "bg-transparent text-white" : "bg-white text-black"}`}
    >
      <div>
        <h2
          className={`pb-0 text-left text-3xl font-[500] ml-0 tracking-[1px] ${
            isdarkMode ? "text-white" : "text-black"
          }`}
        >
          Alerts
        </h2>

        <div className="flex  gap-4">
          {/* Alerts */}
          <Card
            title={
              <span className={isdarkMode ? "text-white" : "text-black"}>
                Alerts
              </span>
            }
            // extra={<Button type="primary" onClick={()=>showDrawer()}> Add +</Button>}
            bodyStyle={{ padding: 0 }}
            className={` w-1/4 rounded-md shadow h-[90vh] p-0 ${isdarkMode ? "bg-transparent" : "bg-white"}`}
          >
            {/* <Input.Search placeholder="Search" allowClear onSearch={handleSearch} className="my-3 w-[96%] mx-1" /> */}
            <div>
              <Input.Search
                placeholder="Search Alerts"
                allowClear
                onSearch={handleAlertsSearch}
                onChange={(e) => handleAlertsSearch(e.target.value)}
                className="my-3 w-[96%] mx-1"
              />
              {/* <Radio.Group
                onChange={(e) => {
                  const { alertID, alertName } = e.target.value;
                  //console.log(
                    "Selected ID:",
                    alertID,
                    "Selected Name:",
                    alertName
                  );
                  setSelectedAlertTable(alertID);
                }}
                style={{ width: "100%" }}
                className={`flex flex-col gap-2 px-0 border-t-2 ${
                  isdarkMode ? "text-white" : "text-black"
                }`}
              >
                {alerts.map((item) => (
                  <Radio
                    key={item.alertID}
                    value={{ alertID: item.alertID, alertName: item.alertName }}
                    className={`${
                      isdarkMode ? "text-white" : "text-black"
                    } w-full py-2 border-b-2 pl-1`}
                  >
                    {item.alertName}
                  </Radio>
                ))}
              </Radio.Group> */}
              <div
                className={`${isdarkMode ? "ag-theme-quartz-dark" : "ag-theme-alpine"}`}
                style={{
                  "--ag-header-background-color":
                    color.themeConfig.colorPrimary,
                  "--ag-header-foreground-color": "#fff",
                  height: 600,
                  width: "100%",
                  overflowY: "auto",
                }}
              >
                <AgGridReact
                  ref={alertsRef}
                  rowData={alerts}
                  columnDefs={alertsCols}
                  rowSelection="single"
                  onSelectionChanged={onAlertsSelection}
                />
              </div>
            </div>
          </Card>

          {/* Sub-Category */}
          <Card
            title={
              <span className={isdarkMode ? "text-white" : "text-black "}>
                Sub-Category
              </span>
            }
            extra={
              <Button type="primary" onClick={() => showDrawer2()}>
                Add +
              </Button>
            }
            className={`p-0 w-1/4 rounded-md shadow ${isdarkMode ? "bg-transparent" : "bg-white"}`}
            bodyStyle={{ padding: 0 }}
          >
            <Input.Search
              placeholder="Search Sub Categories"
              allowClear
              onSearch={handleSubCategoriesSearch}
              onChange={(e) => handleSubCategoriesSearch(e.target.value)}
              className="my-3 w-[96%] mx-1"
            />
            {/* <Radio.Group
              style={{ width: "100%" }}
              className={`flex flex-col gap-2 px-0 border-t-2 ${isdarkMode ? "text-white" : "text-black"}`}
            >

              {subCategories.map((item) => (
                <Radio
                  key={item}
                  value={item.subAutoID}
                  className={`${isdarkMode ? "text-white" : "text-black"} w-full py-2 border-b-2 pl-1`}
                >
                  {item.subCatagory}
                </Radio>
              ))}
            </Radio.Group> */}
            <div
              className={`${isdarkMode ? "ag-theme-quartz-dark" : "ag-theme-alpine"}`}
              style={{
                "--ag-header-background-color": color.themeConfig.colorPrimary,
                "--ag-header-foreground-color": "#fff",
                height: 600,
                width: "100%",
                overflowY: "auto",
              }}
            >
              <AgGridReact
                ref={gridRef}
                rowData={subCategories}
                columnDefs={subCategoryCols}
                // rowSelection="multiple"
                rowSelection="single"
                onSelectionChanged={onSelectionChanged}
              />
            </div>
          </Card>

          {/* Recipient with AgGrid */}
          <Card
            title={
              <span className={isdarkMode ? "text-white" : "text-black"}>
                Recipient
              </span>
            }
            extra={
              <Button type="primary" onClick={() => showDrawer3()}>
                Add +
              </Button>
            }
            className={`p-0 rounded-md w-2/3 shadow ${isdarkMode ? "bg-transparent" : "bg-white"}`}
            bodyStyle={{ padding: 0 }}
          >
            {/* <Input.Search placeholder="Search" className="my-3 mx-1 w-[98%]" /> */}
            <Input.Search
              placeholder="Search Recipients"
              allowClear
              onSearch={handleRecipientsSearch}
              onChange={(e) => handleRecipientsSearch(e.target.value)}
              className="my-3 w-[96%] mx-1"
            />
            <div
              className={`${isdarkMode ? "ag-theme-quartz-dark" : "ag-theme-alpine"}`}
              style={{
                "--ag-header-background-color": color.themeConfig.colorPrimary,
                "--ag-header-foreground-color": "#fff",
                height: 600,
                width: "100%",
                overflowY: "auto",
              }}
            >
              <AgGridReact
                rowData={recipients}
                columnDefs={
                  selectedAlertTable !== 2 ? recepientCols1 : recepientCols2
                }
                // domLayout="autoHeight"
                rowHeight={50}
              />
            </div>
          </Card>
        </div>
      </div>

      <CustomThemeDrawer
        title="Close"
        showDrawer={showDrawer}
        open={open}
        onClose={onClose}
      >
        <div className="flex flex-col gap-6 mt-2">
          <div>
            <label className="block mb-2 font-medium">Alert Name</label>
            <Input
              placeholder="Enter alert name"
              // value={alertName}
              // onChange={(e) => setAlertName(e.target.value)}
              className={`${isdarkMode ? "darkmode-input" : ""}`}
            />
          </div>

          <div className="flex justify-between gap-4  w-full absolute bottom-0 right-0 p-4">
            <Button onClick={onClose} className="">
              Cancel
            </Button>
            <Button
              type="primary"
              // disabled={!alertName.trim()}
              // onClick={handleAdd}
            >
              Add
            </Button>
          </div>
        </div>
      </CustomThemeDrawer>
      <CustomThemeDrawer
        title="Close"
        showDrawer={showDrawer2}
        open={open2}
        onClose={onClose2}
      >
        <div className="flex flex-col gap-6 mt-2">
          <Form
            form={form2}
            name="add-Group-Config"
            layout="horizontal"
            style={{ maxWidth: 600 }}
            labelCol={{ span: 8 }}
            labelAlign="left"
            className="p-3"
            onFinish={insertsubCategory}
          >
            {/* Group Name */}
            <Form.Item
              label={
                <span className={isdarkMode ? "text-white" : "text-black"}>
                  Alert
                </span>
              }
              name="alerts"
              rules={[{ required: true, message: "Please select alert!" }]}
            >
              <Select
                placeholder="Select an alert"
                dropdownClassName={
                  isdarkMode
                    ? "select-dropdown-background"
                    : "light-mode-dropdown"
                }
                className={`${
                  isdarkMode
                    ? "custom-select-dark select-dropdown-background"
                    : "custom-select-light"
                } w-80`}
              >
                {alertsData.map((i) => (
                  <Option key={i.alertID} value={i.alertID}>
                    {i.alertName}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              label={
                <span className={isdarkMode ? "text-white" : "text-black"}>
                  Sub Category
                </span>
              }
              name="subCategory"
              rules={[{ required: true, message: "Please fill Sub category!" }]}
            >
              <Input
                className={
                  isdarkMode ? "dark-input-number" : "light-input-number"
                }
                placeholder="Enter a sub category"
              />
            </Form.Item>
          </Form>

          <div className="flex justify-between gap-4  w-full absolute bottom-0 right-0 p-4">
            <Button onClick={onClose2} className="">
              Cancel
            </Button>
            <Button type="primary" onClick={() => form2.submit()}>
              Add
            </Button>
          </div>
        </div>
      </CustomThemeDrawer>
      <CustomThemeDrawer
        title="Close"
        showDrawer={showDrawer3}
        open={open3}
        onClose={onClose3}
      >
        <div className="flex flex-col gap-6 mt-2">
          <Form
            form={form3}
            name="add-Group-Config"
            layout="horizontal"
            style={{
              maxWidth: 600,
            }}
            labelCol={{
              span: 8,
            }}
            labelAlign="left"
            onFinish={insertRecipient}
            className="p-3"
          >
            <Form.Item
              label={
                <span className={isdarkMode ? "text-white" : "text-black"}>
                  Alert
                </span>
              }
              name="alerts"
              rules={[{ required: true, message: "Please select alert!" }]}
            >
              <Select
                value={selectedAlert}
                onChange={(value) => setSelectedAlert(value)}
                // style={{ width: 200 }}
                labelInValue
                placeholder="Select an alert"
                dropdownClassName={
                  isdarkMode
                    ? "select-dropdown-background"
                    : "light-mode-dropdown"
                }
                className={`  ${isdarkMode ? "custom-select-dark select-dropdown-background" : "custom-select-light"} w-80 `}
              >
                {alertsData.map((i) => (
                  <Option key={i.alertID} value={i.alertName}>
                    {i.alertName}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              // label="Sub Category"
              label={
                <span className={isdarkMode ? "text-white" : "text-black"}>
                  Sub Category
                </span>
              }
              name="subCategory"
              rules={[
                { required: true, message: "Please fill  Sub category!" },
              ]}
            >
              <Select
                // value={selectedValue}
                // onChange={handleChange}
                // style={{ width: 200 }}
                labelInValue
                placeholder="Select a sub category"
                dropdownClassName={
                  isdarkMode
                    ? "select-dropdown-background"
                    : "light-mode-dropdown"
                }
                className={`  ${isdarkMode ? "custom-select-dark select-dropdown-background" : "custom-select-light"} w-80 `}
              >
                {selectedAlert &&
                  subFormCategories.map((i) => (
                    <Option key={i.subAutoID} value={i.subAutoID}>
                      {i.subCatagory}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
            <Form.Item
                  name="recipientName"
                  label={
                    <span className={isdarkMode ? "text-white" : "text-black"}>
                      Recipient Name
                    </span>
                  }
                  rules={[
                    { required: true, message: "Please enter your name" },
                    { type: "text", message: "Enter a valid name" },
                  ]}
                >
                  <Input
                    className={
                      isdarkMode ? "dark-input-number" : "light-input-number"
                    }
                    placeholder="Please enter your name"
                  />
                </Form.Item>
            {selectedAlert?.label === "Email" && (
              <>
                <Form.Item
                  name="recipientType"
                  label={
                    <span className={isdarkMode ? "text-white" : "text-black"}>
                      Recipient Type
                    </span>
                  }
                  rules={[
                    {
                      required: true,
                      message: "Please select at least one recipient type",
                    },
                  ]}
                >
                  <Checkbox.Group>
                    <Checkbox value="to">To</Checkbox>
                    <Checkbox value="cc">CC</Checkbox>
                    <Checkbox value="bcc">BCC</Checkbox>
                  </Checkbox.Group>
                </Form.Item>

                <Form.Item
                  name="emailID"
                  label={
                    <span className={isdarkMode ? "text-white" : "text-black"}>
                      Email
                    </span>
                  }
                  rules={[
                    { required: true, message: "Please enter your email" },
                    { type: "email", message: "Enter a valid email" },
                  ]}
                >
                  <Input
                    className={
                      isdarkMode ? "dark-input-number" : "light-input-number"
                    }
                    placeholder="you@example.com"
                  />
                </Form.Item>
              </>
            )}

            {/* {selectedAlert == "Email" && (
              <Form.Item
                name="emailID"
                label={
                  <span className={isdarkMode ? "text-white" : "text-black"}>
                    Email
                  </span>
                }
                // label="Email"
                rules={[
                  { required: true, message: "Please enter your email" },
                  { type: "email", message: "Enter a valid email" },
                ]}
              >
                <Input
                  className={
                    isdarkMode ? "dark-input-number" : "light-input-number"
                  }
                  placeholder="you@example.com"
                />
              </Form.Item>
            )} */}
            {selectedAlert?.label !== "Email" && (
              <Form.Item
                // label="Phone Number"
                label={
                  <span className={isdarkMode ? "text-white" : "text-black"}>
                    Phone Number
                  </span>
                }
                name="PhoneNumber"
                rules={[
                  {
                    required: true,
                    message: "Please enter your mobile number",
                  },
                  {
                    pattern: /^[0-9]{10}$/,
                    message: "Enter a valid 10-digit mobile number",
                  },
                ]}
              >
                <InputNumber
                  style={{
                    width: "100%",
                  }}
                  className={
                    isdarkMode ? "dark-input-number" : "light-input-number"
                  }
                  placeholder="Enter your mobile number"
                />
              </Form.Item>
            )}
          </Form>

          <div className="flex justify-between gap-4  w-full absolute bottom-0 right-0 p-4">
            <Button onClick={onClose3} className="">
              Cancel
            </Button>
            <Button type="primary" onClick={() => form3.submit()}>
              Add
            </Button>
          </div>
        </div>
      </CustomThemeDrawer>
    </div>
  );
};

export default DashboardLayout;
